/* eslint-disable no-unused-vars */
import React from 'react';
import style from './requests.module.scss';
import { selectUsers } from 'store/admin/adminSlice';
import { useAppSelector } from 'store/hooks';
import map from 'lodash-es/map';
import AdminHeader from 'components/adminHeader/adminHeader';
import AdminList from 'components/adminList/adminList';
import RequestItem from 'components/adminList/requestItem/requestItem';
import FakeRequestItem from 'components/adminList/requestItem/fakeRequestItem';

export default function Cabinet() {
  const users = useAppSelector(selectUsers);

  const items =
    users === null
      ? map(Array(10), (v, i) => <FakeRequestItem key={i}></FakeRequestItem>)
      : map(users, (u) => <RequestItem key={u._id} user={u}></RequestItem>);

  return (
    <div className={style.container}>
      <AdminHeader
        entity={location.pathname.split('/').slice(-1)[0]}
      ></AdminHeader>
      <AdminList
        text={
          items.length
            ? 'Список заявок на предоставление доступа'
            : 'Список заявок пуст'
        }
      >
        {items.length ? items : ''}
      </AdminList>
    </div>
  );
}
